module.exports = __webpack_public_path__ + "static/media/shopee.5d22d8f6.svg";